import * as moment from "moment";
import { auth, storage, database } from "../firebase";

export const retrieveLibrary = async (info) => {
  try {
    const fileList = [];
    const allFiles = await database
      .collection("companies")
      .doc(info.company)
      .collection("library")
      .orderBy("timestamp")
      .get();
    if (allFiles.size > 0) {
      allFiles.forEach((file) => {
        const single = fetchFile(file.id, file.data());
        fileList.push(single);
      });
    }
    return Promise.all(fileList).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchFile = (fileId, file) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(file.owner)
      .get()
      .then((user) => {
        if (user.exists) {
          const isPassword = file.password === null;
          resolve({
            key: fileId,
            downloadLink: isPassword ? file.downloadLink : null,
            name: file.name,
            type: file.type,
            timestamp: file.timestamp,
            password: !isPassword,
            owner: `${user.data().firstName} ${user.data().lastName}`,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const unlockLibraryFile = async (info) => {
  try {
    const file = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("library")
      .doc(info.key)
      .get();
    if (file.exists) {
      if (file.data().password === info.password) {
        return { error: null, payload: file.data().downloadLink };
      } else {
        throw new Error("Feil passord, prøv igjen.");
      }
    } else {
      throw new Error("Filen eksisterer ikke.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteLibraryFile = async (info) => {
  try {
    const file = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("library")
      .doc(info.key)
      .get();
    if (file.exists) {
      if (file.data().downloadLink) {
        await storage.refFromURL(file.data().downloadLink).delete();
        await database
          .collection("companies")
          .doc(info.companyId)
          .collection("library")
          .doc(info.key)
          .delete();
        return { error: null };
      } else {
        throw new Error("Filen eksisterer ikke.");
      }
    } else {
      throw new Error("Filen eksisterer ikke.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const prepareFileUpload = async (info) => {
  try {
    if (info.password && info.password !== "") {
      const dataInput = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("library")
        .add({ password: info.password });
      const fileInfo = {
        file: info.file,
        password: info.password,
        companyId: info.companyId,
        id: dataInput.id,
        owner: auth.currentUser.uid,
      };
      await uploadFile(fileInfo);
      return { error: null };
    } else {
      const dataInput = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("library")
        .add({ password: null });
      const fileInfo = {
        file: info.file,
        companyId: info.companyId,
        id: dataInput.id,
        owner: auth.currentUser.uid,
      };
      await uploadFile(fileInfo);
      return { error: null };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const uploadFile = async (info) => {
  try {
    var storageRef = storage.ref();
    var uploadRef = storageRef.child(
      `hosting/company/${info.companyId}/library/${info.id}/${info.file.name}`
    );
    const fileUpload = await uploadRef.put(info.file);
    const fileName = fileUpload.metadata.name;
    const url = await getFileDownloadUrl(info, fileName);
    await appendLibraryFile(info, url);
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

const getFileDownloadUrl = async (info, filename) => {
  try {
    var storageRef = storage.ref();
    var downloadRef = storageRef.child(
      `hosting/company/${info.companyId}/library/${info.id}/${filename}`
    );
    return await downloadRef.getDownloadURL();
  } catch (e) {
    throw new Error(e);
  }
};

const appendLibraryFile = async (info, url) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("library")
      .doc(info.id)
      .update({
        downloadLink: url,
        type: info.file && info.file.type,
        timestamp: moment().unix(),
        name: info.file && info.file.name,
        owner: info.owner,
      });
  } catch (e) {
    throw new Error(e);
  }
};

const validateFilePasswordSubmit = async (details) => {
  try {
    const file = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("library")
      .doc(details.info.key)
      .get();
    if (file.exists) {
      if (file.data().password) {
        var existingPassword = file.data().password;
        if (details.password === existingPassword) {
          return { error: null };
        } else {
          throw new Error("Feil passord, vennligst prøv igjen.");
        }
      } else {
        throw new Error("Filen har ikke passord.");
      }
    } else {
      throw new Error("Filen eksisterer ikke.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const removeFilePassword = async (details) => {
  try {
    await validateFilePasswordSubmit(details);
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("library")
      .doc(details.info.key)
      .update({ password: null });
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const setNewFilePassword = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("library")
      .doc(details.info.key)
      .update({ password: details.password });
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteFileArray = async (details) => {
  try {
    if (details && details.items.length > 0) {
      const deletions = [];
      details.items.forEach((id) => {
        const single = deleteSingleFile({
          companyId: details.companyId,
          key: id,
        });
        deletions.push(single);
      });

      return Promise.all(deletions).then((result) => {
        return { error: null };
      });
    } else {
      throw new Error("Kunne ikke slette lister.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteSingleFile = async (details) => {
  try {
    const fileInfo = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("library")
      .doc(details.key)
      .get();
    await storage.refFromURL(fileInfo.data().downloadLink).delete();
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("library")
      .doc(details.key)
      .delete();
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};
